
    import Tenant from '@/store/modules/system/tenant/entity';
    import { Component, Mixins, FormModalMixins} from "@/lib";

    @Component
    export default class EditTenant extends Mixins(FormModalMixins){
        model = new Tenant();
        created(){
            Object.assign(this.config, { modelTitleL: "Action.Edit",labelWidth:150, okAction:"system/tenant/update"});
        }
        get record(){
            return this.$store.state.system.tenant.editTenant;
        }
    }
